<template>
    <div class="container">
        <h1 class="title">
            Calculators
        </h1>
        <p class="subtitle">
            Various Guild Wars 2 calculators
        </p>
        <div class="columns">
            <div class="column is-3">
                <div class="container">
                    <b-menu :accordion="false">
                        <b-menu-list label="General">
                            <b-menu-item icon="information-outline" tag="router-link" label="About"
                                         :to="{name: 'calculator-about'}"
                                         :active="$route.name === 'calculator-about'" />
                        </b-menu-list>
                        <b-menu-list label="PvE">
                            <b-menu-item icon="food" tag="router-link" label="Ascended food"
                                         :to="{name: 'calculator-ascended-food'}"
                                         :active="$route.name === 'calculator-ascended-food'" />
                          <b-menu-item icon="target" tag="router-link" label="Assassin's gear options"
                                       :to="{name: 'calculator-gear-precision'}"
                                       :active="$route.name === 'calculator-gear-precision'" />
                        </b-menu-list>
                        <b-menu-list label="Raid">
                            <b-menu-item icon="square-outline" tag="router-link" label="Decoration drop probability"
                                         :to="{name: 'calculator-killproofs'}"
                                         :active="$route.name === 'calculator-killproofs'" />
                        </b-menu-list>
                    </b-menu>
                </div>
            </div>
            <div class="column">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'calculators',
        data() {
            return {
            }
        }
    }
</script>

<style>
</style>
